var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{attrs:{"title":_vm.$t('engine.manageText.modalWidget.tooltip.lblLink', _vm.languageEngine)},on:{"click":_vm.openModalLink}},[_c('i',{staticClass:"far fa-link fs-16"})])}
var staticRenderFns = []

export { render, staticRenderFns }